import router from '@/router/index.ts'
function navTo(name) {
  router.push({
    name: name,
  })
}
function pathTo(path) {
  router.push({
    path: path,
  })
}

export default {
  navTo,
  pathTo,
}
